import React, { FC, useEffect } from 'react';
import { useTable, useExpanded } from 'react-table';
import clsx from 'clsx';
import { AuditDetail } from '../../../@types/Audit';
import { DefaultColumnType } from '@td-client-frontend/common';

interface TableProps {
  data: AuditDetail[];
  columns: DefaultColumnType;
  setAllSubRowsExpanded: (state: boolean) => void;
}

export const Table: FC<TableProps> = ({ columns, data, setAllSubRowsExpanded }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data
    },
    useExpanded
  );

  // for some reason isAllExpanded not working, so I use this useEffect

  useEffect(() => {
    const isAllRowsExpanded: boolean = rows.filter((row) => row.canExpand).every((row) => row.isExpanded);
    setAllSubRowsExpanded(isAllRowsExpanded);
  }, [rows, setAllSubRowsExpanded]);

  return (
    <table
      data-testid="activity-detail-table"
      className="table-fixed w-full overflow-auto bg-white"
      {...getTableProps()}
    >
      <thead
        className="sticky top-0 bg-white z-20"
        style={{
          boxShadow: 'inset 0 -1px 0 #D5D7D7'
        }}
      >
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()} key={`table-row-${headerGroup.id}`}>
            {headerGroup.headers.map((column, index) => {
              return (
                <th
                  className={clsx(
                    index === 0 && 'w-14',
                    column.canSort && 'hover:text-gray-45',
                    'text-left font-bold text-lg leading-5 py-4 px-3 text-gray-30'
                  )}
                  {...column.getHeaderProps()}
                  key={`table-header-${column.id}`}
                >
                  {column.render('Header')}
                </th>
              );
            })}
          </tr>
        ))}
      </thead>

      <tbody data-testid="activity-detail-table-body" {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              key={`table-row-${row.id}`}
              className="mb-4 border-b border-gray-20 text-lg leading-5 break-words"
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    className="px-3 py-4 font-effra text-md font-normal"
                    {...cell.getCellProps()}
                    key={`table-data-${cell.value}`}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
